var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DropdownListSearch',{attrs:{"buttonText":_vm.ipListText,"fieldName":"An IP List","isLoading":_vm.isLoading,"options":_vm.options,"selectedOptions":_vm.selectedOptions},on:{"input":_vm.handleInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }